// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/eg_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/LogoAlert.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/currentIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/upcomingIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/pastIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/currentIconWhite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/upcomingIconWhite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/pastIconWhite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/x.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/xWhite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("assets/play.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overflow-x: hidden;
}

nav {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 20%);
  margin-bottom: 2rem;
}

nav ol {
  margin: 0;
}

nav ol li {
  display: inline;
  margin: 0 1rem;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #000;
  background-color: #fafafa;
}

input,
textarea {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  padding: 9px 13px 10px;
  font-size: 15px;
  background-color: #fff;
  resize: none;
  width: 100%;
}

form label {
  display: block;
  margin: 18px 0 5px;
  line-height: 16px;
  font-size: 14px;
  font-weight: 700;
}

h1 {
  font-weight: 400;
}

ul {
  list-style: none;
  padding: 0px;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}

button {
  cursor: pointer;
}

button {
  background-color: #2668b6;
  border-radius: 19px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  width: 141px;
  height: 38px;
  border: none;
}

nav button.btn-link {
  padding: 0 !important;
  border: 0;
  background: none;
  box-shadow: none;
}

button:disabled {
  opacity: 0.4;
  filter: alpha(opacity=40);
}

label {
  text-align: left;
  width: 170px;
}

input[type="file"] {
  visibility: hidden;
  position: absolute;
}

.flex {
  display: flex;
}

.col-4 {
  text-align: left;
  flex: 0 0 35.333333%;
  max-width: 37%;
}

.check {
  text-align: center;
}

.header {
  width: 100%;
  height: 65px;
  margin: 10px 0px;
}

.header h1 {
  float: right;
  margin: 30px;
}

.header .buttonRow {
  position: absolute;
  right: 20px;
  top: 24px;
}

.header .settings {
  color: #175195;
  cursor: pointer;
  margin-left: 14px;
}

.logo {
  height: 70px;
  width: 70px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: 70px 70px;
  margin-left: 11px;
}

.alertComm {
  color: #000000;
  font-family: OpenSans-ExtraboldItalic;
  font-size: 16px;
  font-style: italic;
  font-weight: 800;
  line-height: 39px;
  text-align: center;
  padding-left: 38px;
}

.alertCommLogo {
  height: 38px;
  width: 38px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: 38px 38px;
  margin-left: 20px;
}

.rectangle {
  display: inline-block;
  float: left;
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  width: 164px;
  height: 100%;
  min-height: 755px;
  padding-top: 17px;
  margin-top: -5px;
}

.react-container {
  float: left;
  width: calc(100% - 164px);
  height: 100%;
  overflow: hidden;
}

.menuItem {
  display: block;
  width: 164px;
  height: 40px;
  padding-top: 10px;
  text-align: left;
}

.menuItem.selected {
  background-color: #3b82d7 !important;
}

.menuItem.selected p {
  color: white !important;
}

.menuItem:hover {
  text-decoration: none;
}

.menuItem p {
  color: #515151;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  padding-left: 24px;
}

.currentLogo {
  height: 24px;
  width: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-size: 24px 24px;
  margin-left: 10px;
}

.upcomingLogo {
  height: 24px;
  width: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  background-size: 24px 24px;
  margin-left: 10px;
}

.pastLogo {
  height: 24px;
  width: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  background-size: 24px 24px;
  margin-left: 10px;
}

.selected .currentLogo {
  height: 24px;
  width: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
  background-size: 24px 24px;
  margin-left: 10px;
}

.selected .upcomingLogo {
  height: 24px;
  width: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
  background-size: 24px 24px;
  margin-left: 10px;
}

.selected .pastLogo {
  height: 24px;
  width: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
  background-size: 24px 24px;
  margin-left: 10px;
}

.recallListContainer {
  margin-top: 10px;
}

.titleRow {
  margin-bottom: 15px;
}

.recallNotice {
  color: #737373;
  font-size: 28px;
  font-weight: 300;
  line-height: 34px;
  text-align: left;
}

.createRecall {
  float: right;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  text-align: center;
}

.cancel {
  background-color: #64abff;
  color: #fff;
  float: right;
}

.save {
  background-color: #8cc717;
  color: #fff;
  float: right;
  margin-left: 7px;
}

.recalls {
  width: 194px;
  min-height: 20px;
  float: left;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 567px;
  padding-left: 2px;
  margin-right: 2px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.recalls::-webkit-scrollbar {
  display: none;
}

.recallFilter {
  border: none;
  background-color: #f1f0f0;
  border-radius: 16px;
  box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.2);
  width: 186px;
  height: 32px;
  color: #3b82d7;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: center;
  margin-bottom: 8px;
}

.recallFilter:focus {
  outline: none;
}

.recall {
  background-color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  width: 196px;
  height: 48px;
  color: #515151;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  padding: 15px 10px;
  margin: 8px 0px;
  cursor: pointer;
}

.recall.selected {
  background-color: #3b82d7;
  color: #fff;
}

.recallDisplay {
  background-color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  width: calc(100% - 196px);
  float: left;
  min-height: 560px;
}

.createContainer {
  margin-top: 15px;
  background-color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  position: relative;
}

.add {
  position: absolute;
  top: 19px;
  right: 30px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  width: 30px;
  height: 30px;
  background-size: 24px 24px;
}

.add:focus {
  outline: none;
}

.addIcon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  width: 30px;
  height: 30px;
  background-size: 24px 24px;
  display: inline-block;
}

.addText {
  position: relative;
  top: -13px;
}

.activeRecall {
  margin: 21px 0px 0px 15px;
}

.remove {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  float: right;
}

.remove:focus {
  outline: none;
}

.removeWhite {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  float: right;
  cursor: pointer;
}

.removeWhite:focus {
  outline: none;
}

.play {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  width: 30px;
  height: 30px;
  background-size: 24px 24px;
  cursor: pointer;
  position: relative;
  top: 4px;
  float: right;
}

.play:focus {
  outline: none;
}

.buttonRow button {
  float: right;
  margin: 8px 4px;
  color: white;
}

#phone {
  margin-bottom: 15px;
}

.radio {
  width: 20px;
}

.createContainer .row {
  padding-top: 20px;
}

.createHeader {
  margin-top: 25px;
  color: #515151;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
}

.inputContainer,
.transcriptContainer {
  padding: 10px 20px;
  width: 100%;
}

.valueContainer {
  margin-top: 15px;
  background-color: #fafafa;
  width: 100%;
  height: 333px;
}

.valueContainer ul {
  list-style-type: none;
  padding-left: 15px;
  padding-right: 8px;
}

.read-affected-items {
  color: #515151;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  position: absolute !important;
}

.sendContainer {
  margin-top: 15px;
}

.send-immediately {
  color: #515151;
  font-size: 18px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
}

.or-schedule {
  color: #737373;
  font-size: 12px;
  font-weight: 400;
  display: block;
  margin: 18px 0px 6px 6px;
}

.createRecallButton {
  background-color: #e6e6e6;
  color: #515151;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  border-radius: 0px;
  border: none;
  margin: 3px;
  height: 32px;
}

.import {
  width: 100%;
  background-color: #64abff;
  height: 32px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  border-radius: 0px;
  margin-top: 14px;
}

.header input {
  font-family: Arial, FontAwesome;
  background-color: #f1f0f0;
  border-radius: 16px;
  box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.2);
  width: 747px;
  height: 32px;
  margin-top: 12px;
}

.header input:focus {
  outline: none;
}

.dropdown-menu.show {
  width: 747px !important;
}

.transcriptHolder {
  height: 200px;
  color: #737373;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
}

.selectedSeverity {
  background-color: #f4ca28 !important;
  color: #fff !important;
}

.selectedRecallButton {
  background-color: #3b82d7 !important;
  color: #fff !important;
}

.selectStores {
  color: #2668b6;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  width: 120px;
  padding-top: 12px;
}

/* Recall Details */
.detailContainer {
  margin: 10px;
}

.summary {
  min-height: 320px;
}

.detailTitle {
  color: #737373;
  font-size: 28px;
  font-weight: 300;
  line-height: 34px;
  text-align: left;
  font-style: normal;
  display: inline-block;
}

.tooltips {
  position: relative;
  display: inline-block;
}

.tooltips .tooltiptext {
  visibility: hidden;
  width: 130px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltips .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltips:hover .tooltiptext {
  visibility: visible;
}

.editButton,
.checkButton,
.deleteButton {
  color: #2668b6;
  width: 18px;
  height: 32px;
  border: none;
  display: inline-block;
  text-align: center;
  padding-top: 5px;
  text-decoration: none;
  margin-left: 10px;
  position: relative;
  top: -5px;
}

.editButton:hover {
  text-decoration: none;
  color: #2668b6;
}

.checkButton {
  cursor: pointer;
  color: #8cc717 !important;
}

.checkButton:hover {
  text-decoration: none;
  color: #8cc717;
}

.deleteButton {
  cursor: pointer;
  color: #ff5f5f !important;
}

.deleteButton:hover {
  text-decoration: none;
  color: #ff5f5f;
}

.sendDate {
  color: #515151;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
}

.status {
  color: #8cc717;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  padding-left: 5px;
}

.detailContainer .transcript {
  color: #737373;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  width: 100%;
  height: 80px;
  text-align: left;
  border: none;
  padding: 0px;
  margin: 5px 0px;
}

.affectedContainer {
  padding-top: 10px;
}

.affectedTitle {
  color: #515151;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
}

.affectedProducts li {
  color: #515151;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  text-align: left;
}

.storesTitle {
  color: #515151;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
}

.storesContainer {
  padding: 8px 45px;
}

.callsLog {
  color: #737373;
  font-size: 18px;
  font-weight: 300;
  line-height: 22px;
  text-align: left;
  display: inline;
  margin-right: 20px;
}

.callsTotals {
  color: #515151;
  font-size: 12px;
  font-weight: 300;
  line-height: 14px;
  text-align: left;
}

.selectionCounts {
  color: #2668b6;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  padding-left: 10px;
}

.errorLabel {
  color: #ff5f5f;
}

.doughnutContainer {
  position: absolute;
  right: -20px;
}

.confirmedPercent {
  position: absolute;
}

.confirmedPercent span {
  color: #737373;
  font-size: 52px;
  font-weight: 200;
  position: absolute;
  left: 120px;
  top: 50px;
  width: 120px;
  text-align: center;
}

.confirmedLabel {
  color: #737373;
  font-size: 12px !important;
  font-weight: 400;
  position: absolute;
  left: 140px;
  top: 120px;
}

.unitsLost {
  color: #515151;
  font-size: 24px;
  font-weight: 600;
  line-height: 33px;
  width: 135px;
  text-align: center;
  margin: auto;
  padding-top: 10px;
}

.export {
  color: #ffffff;
  height: 26px;
  font-size: 14px;
  font-weight: 600;
  line-height: 26px;
  width: 77.13px;
  text-align: center;
  float: right;
  background-color: #2668b6;
  border-radius: 19px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
}

.export:hover {
  color: #ffffff;
  text-decoration: none;
}

.accordionContainer table {
  border-top: none;
  width: 100%;
}

.accordionContainer tr {
  border-bottom: 1px solid #e6e6e6;
  height: 40px;
}

.incompleteRow .title {
  color: #000000;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  width: 33%;
}

.incompleteRow .lastAttempt {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
}

.incompleteRow .incomplete {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: right;
}

.completeRow .title {
  color: #000000;
  font-size: 18px;
  font-weight: 300;
  line-height: 22px;
  text-align: left;
  width: 33%;
}

.completeRow .completed {
  color: #2668b6;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
}

.completeRow .lost {
  color: #2668b6;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: right;
}

.completeRow .lostCount {
  color: #000;
  font-weight: 600;
  margin-left: 2px;
}

.filter {
  color: #3b82d7;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: center;
  float: right;
  margin-right: 20px;
  margin-top: 6px;
  cursor: pointer;
}

.currentFilter {
  background-color: #64abff;
  border-radius: 19px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  height: 26px;
  float: right;
  color: white;
  min-width: 110px;
  margin-right: 10px;
  padding-left: 10px;
}

/* React Tabs */

.pretty {
  top: 3px;
}

.pretty input {
  height: 18px;
  width: 150px;
}

.react-datepicker-wrapper,
.react-datepicker__input-container {
  width: 100% !important;
}

.react-tabs__tab-list {
  border-bottom: 1px solid #e6e6e6 !important;
}

.react-tabs__tab {
  padding: 8px 20px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 14px !important;
  text-align: left !important;
  background-color: #e6e6e6 !important;
  color: #515151 !important;
}

.react-tabs__tab--selected {
  border-radius: 0px !important;
  background-color: #64abff !important;
  color: white !important;
}

.react-datepicker__time-container {
  width: 90px !important;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box {
  width: 88px !important;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 95px !important;
}

.jss10 {
  width: 28px !important;
  height: 28px !important;
  margin-right: 20px !important;
}

/* Accordion */

.Collapsible {
  background-color: white;
  cursor: pointer;
}

.Collapsible__contentInner {
  padding: 10px;
  border: 1px solid #ebebeb;
  border-top: 0;
}
.Collapsible__contentInner p {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
}
.Collapsible__contentInner p:last-child {
  margin-bottom: 0;
}

.Collapsible__trigger {
  display: block;
  color: #ff5f5f;
  font-size: 12px;
  font-weight: 600;
  line-height: 2px;
  text-decoration: none;
  position: relative;
  border: 1px solid white;
  padding: 10px;
  background-color: #ffd7d7;
  height: 24px;
}

.accordionContainer {
  margin-top: 10px;
}

.accordionContainer .Collapsible:nth-child(2) .Collapsible__trigger {
  background-color: #e6e6e6 !important;
  color: #a4a4a4 !important;
}

.Collapsible__trigger:after {
  font-family: "FontAwesome";
  content: "\\f107";
  position: absolute;
  right: 10px;
  top: 10px;
  display: block;
  transition: transform 300ms;
}
.Collapsible__trigger.is-open:after {
  transform: rotateZ(180deg);
}
.Collapsible__trigger.is-disabled {
  opacity: 0.5;
  background-color: grey;
}

.CustomTriggerCSS {
  background-color: lightcoral;
  transition: background-color 200ms ease;
}

.CustomTriggerCSS--open {
  background-color: darkslateblue;
}

.Collapsible__custom-sibling {
  padding: 5px;
  font-size: 12px;
  background-color: #cbb700;
  color: black;
}

/* Config */

.configContainer .transcript {
  height: 250px;
}

.configContainer .actionText {
  height: 120px;
}

.configContainer input {
  width: 70px;
  display: inline-block;
}

.configContainer label {
  color: #515151;
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  text-align: left;
  width: 100% !important;
}

.configContainer .minutes {
  color: #515151;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  text-align: left;
  margin-left: 10px;
}

/* Timeline */

.timelineContainer .fa-check,
.timelineContainer .fa-calendar,
.timelineContainer .fa-circle-o-notch {
  color: green;
}

.timelineContainer section {
  overflow-y: scroll;
  height: 600px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAEhB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAA+C;EAC/C,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAiD;EACjD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAmD;EACnD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAoD;EACpD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAgD;EAChD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAwD;EACxD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAyD;EACzD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6DAAqD;EACrD,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6DAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6DAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8DAA8C;EAC9C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8DAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,cAAc;;AAEd;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA,WAAW;;AAEX;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,aAAa;;AAEb;;;EAGE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["html {\r\n  overflow-x: hidden;\r\n}\r\n\r\nnav {\r\n  display: flex !important;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  box-shadow: 0 0 4px 0 rgb(0 0 0 / 20%);\r\n  margin-bottom: 2rem;\r\n}\r\n\r\nnav ol {\r\n  margin: 0;\r\n}\r\n\r\nnav ol li {\r\n  display: inline;\r\n  margin: 0 1rem;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-weight: 400;\r\n  color: #000;\r\n  background-color: #fafafa;\r\n}\r\n\r\ninput,\r\ntextarea {\r\n  border: none;\r\n  border-bottom: 1px solid #e6e6e6;\r\n  padding: 9px 13px 10px;\r\n  font-size: 15px;\r\n  background-color: #fff;\r\n  resize: none;\r\n  width: 100%;\r\n}\r\n\r\nform label {\r\n  display: block;\r\n  margin: 18px 0 5px;\r\n  line-height: 16px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\nh1 {\r\n  font-weight: 400;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n  padding: 0px;\r\n}\r\n\r\n.left {\r\n  text-align: left;\r\n}\r\n\r\n.right {\r\n  text-align: right;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\nbutton {\r\n  background-color: #2668b6;\r\n  border-radius: 19px;\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\r\n  width: 141px;\r\n  height: 38px;\r\n  border: none;\r\n}\r\n\r\nnav button.btn-link {\r\n  padding: 0 !important;\r\n  border: 0;\r\n  background: none;\r\n  box-shadow: none;\r\n}\r\n\r\nbutton:disabled {\r\n  opacity: 0.4;\r\n  filter: alpha(opacity=40);\r\n}\r\n\r\nlabel {\r\n  text-align: left;\r\n  width: 170px;\r\n}\r\n\r\ninput[type=\"file\"] {\r\n  visibility: hidden;\r\n  position: absolute;\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\n.col-4 {\r\n  text-align: left;\r\n  -webkit-flex: 0 0 35.333333%;\r\n  flex: 0 0 35.333333%;\r\n  max-width: 37%;\r\n}\r\n\r\n.check {\r\n  text-align: center;\r\n}\r\n\r\n.header {\r\n  width: 100%;\r\n  height: 65px;\r\n  margin: 10px 0px;\r\n}\r\n\r\n.header h1 {\r\n  float: right;\r\n  margin: 30px;\r\n}\r\n\r\n.header .buttonRow {\r\n  position: absolute;\r\n  right: 20px;\r\n  top: 24px;\r\n}\r\n\r\n.header .settings {\r\n  color: #175195;\r\n  cursor: pointer;\r\n  margin-left: 14px;\r\n}\r\n\r\n.logo {\r\n  height: 70px;\r\n  width: 70px;\r\n  background: url(\"assets/eg_logo.png\") no-repeat;\r\n  background-size: 70px 70px;\r\n  margin-left: 11px;\r\n}\r\n\r\n.alertComm {\r\n  color: #000000;\r\n  font-family: OpenSans-ExtraboldItalic;\r\n  font-size: 16px;\r\n  font-style: italic;\r\n  font-weight: 800;\r\n  line-height: 39px;\r\n  text-align: center;\r\n  padding-left: 38px;\r\n}\r\n\r\n.alertCommLogo {\r\n  height: 38px;\r\n  width: 38px;\r\n  background: url(\"assets/LogoAlert.png\") no-repeat;\r\n  background-size: 38px 38px;\r\n  margin-left: 20px;\r\n}\r\n\r\n.rectangle {\r\n  display: inline-block;\r\n  float: left;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\r\n  width: 164px;\r\n  height: 100%;\r\n  min-height: 755px;\r\n  padding-top: 17px;\r\n  margin-top: -5px;\r\n}\r\n\r\n.react-container {\r\n  float: left;\r\n  width: calc(100% - 164px);\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.menuItem {\r\n  display: block;\r\n  width: 164px;\r\n  height: 40px;\r\n  padding-top: 10px;\r\n  text-align: left;\r\n}\r\n\r\n.menuItem.selected {\r\n  background-color: #3b82d7 !important;\r\n}\r\n\r\n.menuItem.selected p {\r\n  color: white !important;\r\n}\r\n\r\n.menuItem:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.menuItem p {\r\n  color: #515151;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 24px;\r\n  text-align: left;\r\n  padding-left: 24px;\r\n}\r\n\r\n.currentLogo {\r\n  height: 24px;\r\n  width: 24px;\r\n  background: url(\"assets/currentIcon.svg\") no-repeat;\r\n  background-size: 24px 24px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.upcomingLogo {\r\n  height: 24px;\r\n  width: 24px;\r\n  background: url(\"assets/upcomingIcon.svg\") no-repeat;\r\n  background-size: 24px 24px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.pastLogo {\r\n  height: 24px;\r\n  width: 24px;\r\n  background: url(\"assets/pastIcon.svg\") no-repeat;\r\n  background-size: 24px 24px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.selected .currentLogo {\r\n  height: 24px;\r\n  width: 24px;\r\n  background: url(\"assets/currentIconWhite.svg\") no-repeat;\r\n  background-size: 24px 24px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.selected .upcomingLogo {\r\n  height: 24px;\r\n  width: 24px;\r\n  background: url(\"assets/upcomingIconWhite.svg\") no-repeat;\r\n  background-size: 24px 24px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.selected .pastLogo {\r\n  height: 24px;\r\n  width: 24px;\r\n  background: url(\"assets/pastIconWhite.svg\") no-repeat;\r\n  background-size: 24px 24px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.recallListContainer {\r\n  margin-top: 10px;\r\n}\r\n\r\n.titleRow {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.recallNotice {\r\n  color: #737373;\r\n  font-size: 28px;\r\n  font-weight: 300;\r\n  line-height: 34px;\r\n  text-align: left;\r\n}\r\n\r\n.createRecall {\r\n  float: right;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 17px;\r\n  text-align: center;\r\n}\r\n\r\n.cancel {\r\n  background-color: #64abff;\r\n  color: #fff;\r\n  float: right;\r\n}\r\n\r\n.save {\r\n  background-color: #8cc717;\r\n  color: #fff;\r\n  float: right;\r\n  margin-left: 7px;\r\n}\r\n\r\n.recalls {\r\n  width: 194px;\r\n  min-height: 20px;\r\n  float: left;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  height: 567px;\r\n  padding-left: 2px;\r\n  margin-right: 2px;\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.recalls::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.recallFilter {\r\n  border: none;\r\n  background-color: #f1f0f0;\r\n  border-radius: 16px;\r\n  box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.2);\r\n  width: 186px;\r\n  height: 32px;\r\n  color: #3b82d7;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 17px;\r\n  text-align: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.recallFilter:focus {\r\n  outline: none;\r\n}\r\n\r\n.recall {\r\n  background-color: #ffffff;\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\r\n  width: 196px;\r\n  height: 48px;\r\n  color: #515151;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 17px;\r\n  text-align: left;\r\n  padding: 15px 10px;\r\n  margin: 8px 0px;\r\n  cursor: pointer;\r\n}\r\n\r\n.recall.selected {\r\n  background-color: #3b82d7;\r\n  color: #fff;\r\n}\r\n\r\n.recallDisplay {\r\n  background-color: #ffffff;\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\r\n  width: calc(100% - 196px);\r\n  float: left;\r\n  min-height: 560px;\r\n}\r\n\r\n.createContainer {\r\n  margin-top: 15px;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\r\n  position: relative;\r\n}\r\n\r\n.add {\r\n  position: absolute;\r\n  top: 19px;\r\n  right: 30px;\r\n  background: url(\"assets/plus.svg\") no-repeat;\r\n  border: none;\r\n  border-radius: 0px;\r\n  box-shadow: none;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-size: 24px 24px;\r\n}\r\n\r\n.add:focus {\r\n  outline: none;\r\n}\r\n\r\n.addIcon {\r\n  background: url(\"assets/plus.svg\") no-repeat;\r\n  border: none;\r\n  border-radius: 0px;\r\n  box-shadow: none;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-size: 24px 24px;\r\n  display: inline-block;\r\n}\r\n\r\n.addText {\r\n  position: relative;\r\n  top: -13px;\r\n}\r\n\r\n.activeRecall {\r\n  margin: 21px 0px 0px 15px;\r\n}\r\n\r\n.remove {\r\n  background: url(\"assets/x.svg\") no-repeat;\r\n  border: none;\r\n  border-radius: 0px;\r\n  box-shadow: none;\r\n  width: 24px;\r\n  height: 24px;\r\n  background-size: 24px 24px;\r\n  float: right;\r\n}\r\n\r\n.remove:focus {\r\n  outline: none;\r\n}\r\n\r\n.removeWhite {\r\n  background: url(\"assets/xWhite.svg\") no-repeat;\r\n  border: none;\r\n  border-radius: 0px;\r\n  box-shadow: none;\r\n  width: 24px;\r\n  height: 24px;\r\n  background-size: 24px 24px;\r\n  float: right;\r\n  cursor: pointer;\r\n}\r\n\r\n.removeWhite:focus {\r\n  outline: none;\r\n}\r\n\r\n.play {\r\n  background: url(\"assets/play.svg\") no-repeat;\r\n  border: none;\r\n  border-radius: 0px;\r\n  box-shadow: none;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-size: 24px 24px;\r\n  cursor: pointer;\r\n  position: relative;\r\n  top: 4px;\r\n  float: right;\r\n}\r\n\r\n.play:focus {\r\n  outline: none;\r\n}\r\n\r\n.buttonRow button {\r\n  float: right;\r\n  margin: 8px 4px;\r\n  color: white;\r\n}\r\n\r\n#phone {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.radio {\r\n  width: 20px;\r\n}\r\n\r\n.createContainer .row {\r\n  padding-top: 20px;\r\n}\r\n\r\n.createHeader {\r\n  margin-top: 25px;\r\n  color: #515151;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  line-height: 22px;\r\n  text-align: left;\r\n}\r\n\r\n.inputContainer,\r\n.transcriptContainer {\r\n  padding: 10px 20px;\r\n  width: 100%;\r\n}\r\n\r\n.valueContainer {\r\n  margin-top: 15px;\r\n  background-color: #fafafa;\r\n  width: 100%;\r\n  height: 333px;\r\n}\r\n\r\n.valueContainer ul {\r\n  list-style-type: none;\r\n  padding-left: 15px;\r\n  padding-right: 8px;\r\n}\r\n\r\n.read-affected-items {\r\n  color: #515151;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 12px;\r\n  text-align: left;\r\n  position: absolute !important;\r\n}\r\n\r\n.sendContainer {\r\n  margin-top: 15px;\r\n}\r\n\r\n.send-immediately {\r\n  color: #515151;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  line-height: 18px;\r\n  text-align: left;\r\n}\r\n\r\n.or-schedule {\r\n  color: #737373;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  display: block;\r\n  margin: 18px 0px 6px 6px;\r\n}\r\n\r\n.createRecallButton {\r\n  background-color: #e6e6e6;\r\n  color: #515151;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 14px;\r\n  text-align: center;\r\n  border-radius: 0px;\r\n  border: none;\r\n  margin: 3px;\r\n  height: 32px;\r\n}\r\n\r\n.import {\r\n  width: 100%;\r\n  background-color: #64abff;\r\n  height: 32px;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 14px;\r\n  border-radius: 0px;\r\n  margin-top: 14px;\r\n}\r\n\r\n.header input {\r\n  font-family: Arial, FontAwesome;\r\n  background-color: #f1f0f0;\r\n  border-radius: 16px;\r\n  box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.2);\r\n  width: 747px;\r\n  height: 32px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.header input:focus {\r\n  outline: none;\r\n}\r\n\r\n.dropdown-menu.show {\r\n  width: 747px !important;\r\n}\r\n\r\n.transcriptHolder {\r\n  height: 200px;\r\n  color: #737373;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  text-align: left;\r\n}\r\n\r\n.selectedSeverity {\r\n  background-color: #f4ca28 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.selectedRecallButton {\r\n  background-color: #3b82d7 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.selectStores {\r\n  color: #2668b6;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 14px;\r\n  text-align: center;\r\n  width: 120px;\r\n  padding-top: 12px;\r\n}\r\n\r\n/* Recall Details */\r\n.detailContainer {\r\n  margin: 10px;\r\n}\r\n\r\n.summary {\r\n  min-height: 320px;\r\n}\r\n\r\n.detailTitle {\r\n  color: #737373;\r\n  font-size: 28px;\r\n  font-weight: 300;\r\n  line-height: 34px;\r\n  text-align: left;\r\n  font-style: normal;\r\n  display: inline-block;\r\n}\r\n\r\n.tooltips {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.tooltips .tooltiptext {\r\n  visibility: hidden;\r\n  width: 130px;\r\n  background-color: black;\r\n  color: #fff;\r\n  text-align: center;\r\n  border-radius: 6px;\r\n  padding: 5px 0;\r\n  position: absolute;\r\n  z-index: 1;\r\n  bottom: 150%;\r\n  left: 50%;\r\n  margin-left: -60px;\r\n}\r\n\r\n.tooltips .tooltiptext::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: black transparent transparent transparent;\r\n}\r\n\r\n.tooltips:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.editButton,\r\n.checkButton,\r\n.deleteButton {\r\n  color: #2668b6;\r\n  width: 18px;\r\n  height: 32px;\r\n  border: none;\r\n  display: inline-block;\r\n  text-align: center;\r\n  padding-top: 5px;\r\n  text-decoration: none;\r\n  margin-left: 10px;\r\n  position: relative;\r\n  top: -5px;\r\n}\r\n\r\n.editButton:hover {\r\n  text-decoration: none;\r\n  color: #2668b6;\r\n}\r\n\r\n.checkButton {\r\n  cursor: pointer;\r\n  color: #8cc717 !important;\r\n}\r\n\r\n.checkButton:hover {\r\n  text-decoration: none;\r\n  color: #8cc717;\r\n}\r\n\r\n.deleteButton {\r\n  cursor: pointer;\r\n  color: #ff5f5f !important;\r\n}\r\n\r\n.deleteButton:hover {\r\n  text-decoration: none;\r\n  color: #ff5f5f;\r\n}\r\n\r\n.sendDate {\r\n  color: #515151;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  line-height: 22px;\r\n  text-align: left;\r\n}\r\n\r\n.status {\r\n  color: #8cc717;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  line-height: 22px;\r\n  text-align: left;\r\n  padding-left: 5px;\r\n}\r\n\r\n.detailContainer .transcript {\r\n  color: #737373;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 17px;\r\n  width: 100%;\r\n  height: 80px;\r\n  text-align: left;\r\n  border: none;\r\n  padding: 0px;\r\n  margin: 5px 0px;\r\n}\r\n\r\n.affectedContainer {\r\n  padding-top: 10px;\r\n}\r\n\r\n.affectedTitle {\r\n  color: #515151;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  text-align: left;\r\n}\r\n\r\n.affectedProducts li {\r\n  color: #515151;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 19px;\r\n  text-align: left;\r\n}\r\n\r\n.storesTitle {\r\n  color: #515151;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 17px;\r\n  text-align: left;\r\n}\r\n\r\n.storesContainer {\r\n  padding: 8px 45px;\r\n}\r\n\r\n.callsLog {\r\n  color: #737373;\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  line-height: 22px;\r\n  text-align: left;\r\n  display: inline;\r\n  margin-right: 20px;\r\n}\r\n\r\n.callsTotals {\r\n  color: #515151;\r\n  font-size: 12px;\r\n  font-weight: 300;\r\n  line-height: 14px;\r\n  text-align: left;\r\n}\r\n\r\n.selectionCounts {\r\n  color: #2668b6;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 24px;\r\n  text-align: left;\r\n  padding-left: 10px;\r\n}\r\n\r\n.errorLabel {\r\n  color: #ff5f5f;\r\n}\r\n\r\n.doughnutContainer {\r\n  position: absolute;\r\n  right: -20px;\r\n}\r\n\r\n.confirmedPercent {\r\n  position: absolute;\r\n}\r\n\r\n.confirmedPercent span {\r\n  color: #737373;\r\n  font-size: 52px;\r\n  font-weight: 200;\r\n  position: absolute;\r\n  left: 120px;\r\n  top: 50px;\r\n  width: 120px;\r\n  text-align: center;\r\n}\r\n\r\n.confirmedLabel {\r\n  color: #737373;\r\n  font-size: 12px !important;\r\n  font-weight: 400;\r\n  position: absolute;\r\n  left: 140px;\r\n  top: 120px;\r\n}\r\n\r\n.unitsLost {\r\n  color: #515151;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  line-height: 33px;\r\n  width: 135px;\r\n  text-align: center;\r\n  margin: auto;\r\n  padding-top: 10px;\r\n}\r\n\r\n.export {\r\n  color: #ffffff;\r\n  height: 26px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 26px;\r\n  width: 77.13px;\r\n  text-align: center;\r\n  float: right;\r\n  background-color: #2668b6;\r\n  border-radius: 19px;\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.export:hover {\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n}\r\n\r\n.accordionContainer table {\r\n  border-top: none;\r\n  width: 100%;\r\n}\r\n\r\n.accordionContainer tr {\r\n  border-bottom: 1px solid #e6e6e6;\r\n  height: 40px;\r\n}\r\n\r\n.incompleteRow .title {\r\n  color: #000000;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  line-height: 22px;\r\n  text-align: left;\r\n  width: 33%;\r\n}\r\n\r\n.incompleteRow .lastAttempt {\r\n  color: #000000;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  text-align: left;\r\n}\r\n\r\n.incompleteRow .incomplete {\r\n  color: #000000;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  text-align: right;\r\n}\r\n\r\n.completeRow .title {\r\n  color: #000000;\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  line-height: 22px;\r\n  text-align: left;\r\n  width: 33%;\r\n}\r\n\r\n.completeRow .completed {\r\n  color: #2668b6;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  text-align: left;\r\n}\r\n\r\n.completeRow .lost {\r\n  color: #2668b6;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  text-align: right;\r\n}\r\n\r\n.completeRow .lostCount {\r\n  color: #000;\r\n  font-weight: 600;\r\n  margin-left: 2px;\r\n}\r\n\r\n.filter {\r\n  color: #3b82d7;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 17px;\r\n  text-align: center;\r\n  float: right;\r\n  margin-right: 20px;\r\n  margin-top: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.currentFilter {\r\n  background-color: #64abff;\r\n  border-radius: 19px;\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\r\n  height: 26px;\r\n  float: right;\r\n  color: white;\r\n  min-width: 110px;\r\n  margin-right: 10px;\r\n  padding-left: 10px;\r\n}\r\n\r\n/* React Tabs */\r\n\r\n.pretty {\r\n  top: 3px;\r\n}\r\n\r\n.pretty input {\r\n  height: 18px;\r\n  width: 150px;\r\n}\r\n\r\n.react-datepicker-wrapper,\r\n.react-datepicker__input-container {\r\n  width: 100% !important;\r\n}\r\n\r\n.react-tabs__tab-list {\r\n  border-bottom: 1px solid #e6e6e6 !important;\r\n}\r\n\r\n.react-tabs__tab {\r\n  padding: 8px 20px !important;\r\n  font-size: 12px !important;\r\n  font-weight: 600 !important;\r\n  line-height: 14px !important;\r\n  text-align: left !important;\r\n  background-color: #e6e6e6 !important;\r\n  color: #515151 !important;\r\n}\r\n\r\n.react-tabs__tab--selected {\r\n  border-radius: 0px !important;\r\n  background-color: #64abff !important;\r\n  color: white !important;\r\n}\r\n\r\n.react-datepicker__time-container {\r\n  width: 90px !important;\r\n}\r\n\r\n.react-datepicker__time-container\r\n  .react-datepicker__time\r\n  .react-datepicker__time-box {\r\n  width: 88px !important;\r\n}\r\n\r\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\r\n  right: 95px !important;\r\n}\r\n\r\n.jss10 {\r\n  width: 28px !important;\r\n  height: 28px !important;\r\n  margin-right: 20px !important;\r\n}\r\n\r\n/* Accordion */\r\n\r\n.Collapsible {\r\n  background-color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.Collapsible__contentInner {\r\n  padding: 10px;\r\n  border: 1px solid #ebebeb;\r\n  border-top: 0;\r\n}\r\n.Collapsible__contentInner p {\r\n  margin-bottom: 10px;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n}\r\n.Collapsible__contentInner p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.Collapsible__trigger {\r\n  display: block;\r\n  color: #ff5f5f;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 2px;\r\n  text-decoration: none;\r\n  position: relative;\r\n  border: 1px solid white;\r\n  padding: 10px;\r\n  background-color: #ffd7d7;\r\n  height: 24px;\r\n}\r\n\r\n.accordionContainer {\r\n  margin-top: 10px;\r\n}\r\n\r\n.accordionContainer .Collapsible:nth-child(2) .Collapsible__trigger {\r\n  background-color: #e6e6e6 !important;\r\n  color: #a4a4a4 !important;\r\n}\r\n\r\n.Collapsible__trigger:after {\r\n  font-family: \"FontAwesome\";\r\n  content: \"\\f107\";\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 10px;\r\n  display: block;\r\n  transition: transform 300ms;\r\n}\r\n.Collapsible__trigger.is-open:after {\r\n  transform: rotateZ(180deg);\r\n}\r\n.Collapsible__trigger.is-disabled {\r\n  opacity: 0.5;\r\n  background-color: grey;\r\n}\r\n\r\n.CustomTriggerCSS {\r\n  background-color: lightcoral;\r\n  transition: background-color 200ms ease;\r\n}\r\n\r\n.CustomTriggerCSS--open {\r\n  background-color: darkslateblue;\r\n}\r\n\r\n.Collapsible__custom-sibling {\r\n  padding: 5px;\r\n  font-size: 12px;\r\n  background-color: #cbb700;\r\n  color: black;\r\n}\r\n\r\n/* Config */\r\n\r\n.configContainer .transcript {\r\n  height: 250px;\r\n}\r\n\r\n.configContainer .actionText {\r\n  height: 120px;\r\n}\r\n\r\n.configContainer input {\r\n  width: 70px;\r\n  display: inline-block;\r\n}\r\n\r\n.configContainer label {\r\n  color: #515151;\r\n  font-size: 16px;\r\n  font-weight: 300;\r\n  line-height: 19px;\r\n  text-align: left;\r\n  width: 100% !important;\r\n}\r\n\r\n.configContainer .minutes {\r\n  color: #515151;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 17px;\r\n  text-align: left;\r\n  margin-left: 10px;\r\n}\r\n\r\n/* Timeline */\r\n\r\n.timelineContainer .fa-check,\r\n.timelineContainer .fa-calendar,\r\n.timelineContainer .fa-circle-o-notch {\r\n  color: green;\r\n}\r\n\r\n.timelineContainer section {\r\n  overflow-y: scroll;\r\n  height: 600px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
